var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"div"},[_c('button',{staticClass:"close-button",on:{"click":function($event){return _vm.$router.back()}}},[_c('img',{attrs:{"src":require("@/assets/picto_close_qrcode.png")}})]),_c('visite-map',{staticClass:"map"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }